import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // The AI backend lives on another domain, which never receives this API's session cookie.
  const token = req.url.startsWith(`${environment.URL_AI}/`) ? inject(AuthService).bearerToken() : null;
  const setHeaders = token ? { Authorization: `Bearer ${token}` } : undefined;
  return next(req.clone({ withCredentials: true, setHeaders }));
};
